<app-carousel></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <br />
        <div class="card">
            <div class="card-body">
                <h5 class="mt-0 mb-2">
                    <i class="fa-regular fa-building"></i>
                    Acerca de nosotros
                </h5>
                <p class="mt-0 mb-2 text-justify">
                   En RedLaboralRD, somos una plataforma innovadora diseñada para transformar la manera en que el talento y las oportunidades laborales se encuentran en la República Dominicana y en toda la zona hispanohablante. Entendemos el dinamismo del mercado actual y aprovechamos el poder de las redes para simplificar y agilizar el proceso de búsqueda y oferta de empleo. Nos apasiona crear un ecosistema laboral accesible, eficiente y de alto impacto para todos, facilitando conexiones significativas que impulsen el crecimiento profesional de las personas y el éxito de las empresas.
                </p>
                <div class="row mt-2 mb-2">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <h5 class="mt-2 mb-2">
                            Mision
                        </h5>
                        <p class="mt-0 mb-2 text-justify">
                            Facilitar la conexión eficiente entre talento y oportunidades laborales, utilizando el poder de las redes para impulsar el crecimiento profesional de las personas y el éxito de las empresas.
                        </p>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <h5 class="mt-2 mb-2">
                            Vision
                        </h5>
                        <p class="mt-0 mb-2 text-justify">
                            Ser la plataforma líder y referente para la búsqueda y oferta de empleo a través de redes, reconocida por su innovación, efectividad y contribución al desarrollo del mercado laboral.
                        </p>
                    </div>
                </div>
                <h5 class="mt-0 mb-2">
                    Valores
                </h5>
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <ul class="mb-2">
                            <li><strong>Conexión:</strong> Creamos puentes valiosos entre talento y empleadores.</li>
                            <li><strong>Oportunidad:</strong> Brindamos acceso equitativo a diversas oportunidades laborales.</li>
                            <li><strong>Innovación:</strong> Optimizamos la búsqueda de empleo con tecnología creativa.</li>
                            <li><strong>Eficiencia:</strong> Agilizamos procesos para encuentros rápidos y sencillos.</li>
                            
                        </ul>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <ul class="mb-2">
                            <li><strong>Transparencia:</strong> Actuamos con claridad y honestidad para generar confianza.</li>
                            <li><strong>Desarrollo:</strong> Impulsamos el crecimiento profesional y del mercado laboral.</li>
                            <li><strong>Comunidad:</strong> Construimos un espacio colaborativo de conocimiento y oportunidades.</li>
                            <li><strong>Impacto:</strong> Generamos un cambio positivo en personas y empresas del país.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>